/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { TabInfo, TabToAddInfo, TabToUpdateInfo } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class TabClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags Tab
   * @summary Получить вкладки проекта по Id проекта
   * @request GET:/objecttree/Tab/project/{projectId}
   * @secure
   */
  tabGetTabsByProjectId = (
    projectId: string,
    query: {
      /** Необходимость включения скрытых вкладок */
      needIncludeHidden: boolean
    },
    params: RequestParams = {},
  ) =>
    this.http.request<TabInfo[], any>({
      path: `/objecttree/Tab/project/${projectId}`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Tab
   * @summary Получить вкладки проекта по Id рабочей области
   * @request GET:/objecttree/Tab/workarea/{workAreaId}
   * @secure
   */
  tabGetTabsByWorkAreaId = (
    workAreaId: string,
    query: {
      /** Необходимость включения скрытых вкладок */
      needIncludeHidden: boolean
    },
    params: RequestParams = {},
  ) =>
    this.http.request<TabInfo[], any>({
      path: `/objecttree/Tab/workarea/${workAreaId}`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Tab
   * @summary Добавить новую вкладку проекта
   * @request POST:/objecttree/Tab
   * @secure
   */
  tabAddTab = (data: TabToAddInfo, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/objecttree/Tab`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Tab
   * @summary Изменить существующую вкладку проекта
   * @request PUT:/objecttree/Tab
   * @secure
   */
  tabUpdateTab = (data: TabToUpdateInfo, params: RequestParams = {}) =>
    this.http.request<boolean, string>({
      path: `/objecttree/Tab`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Tab
   * @summary Удалить существующую вкладку проекта
   * @request DELETE:/objecttree/Tab
   * @secure
   */
  tabDeleteTab = (
    query: {
      /**
       * Идентификатор вкладки проекта
       * @format uuid
       */
      tabId: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/objecttree/Tab`,
      method: 'DELETE',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Tab
   * @summary Получить или установить значение настройки для вкладки
   * @request GET:/objecttree/Tab/project/{projectId}/tab/{tabId}/GetSettingOfConfig
   * @secure
   */
  tabGetSettingOfConfig = (
    projectId: string,
    tabId: string,
    query: {
      /** Ключ настройки */
      settingKey: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<string, string>({
      path: `/objecttree/Tab/project/${projectId}/tab/${tabId}/GetSettingOfConfig`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Tab
   * @summary Изменить (при отсутствии добавить) параметр в конфигураторе вкладки
   * @request PUT:/objecttree/Tab/project/{projectId}/tab/{tabId}/editSettingOfConfig
   * @secure
   */
  tabEditSettingOfConfig = (
    projectId: string,
    tabId: string,
    query: {
      /** Ключ параметра конфигуратора */
      settingKey: string
      /** Значение параметра конфигуратора */
      settingValue: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/objecttree/Tab/project/${projectId}/tab/${tabId}/editSettingOfConfig`,
      method: 'PUT',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Tab
   * @summary Удалить параметр из конфигуратора вкладки
   * @request DELETE:/objecttree/Tab/project/{projectId}/tab/{tabId}/deleteSettingFromConfig
   * @secure
   */
  tabDeleteSettingFromConfig = (
    projectId: string,
    tabId: string,
    query: {
      /** Ключ параметра конфигуратора */
      settingKey: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/objecttree/Tab/project/${projectId}/tab/${tabId}/deleteSettingFromConfig`,
      method: 'DELETE',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    })
}
